import { useQuery } from "@tanstack/react-query";
import {
  mvpApiListAllJobTasks,
  type MvpApiListAllJobTasksResponse,
} from "@augmodo/lebron-browser-client";

export function useFetchAllJobTasks(queryParams: any) {
  return useQuery({
    queryKey: ["all-job-tasks", queryParams],
    queryFn: async () => {
      const response = await mvpApiListAllJobTasks({
        query: queryParams,
      });

      if (response.error) {
        throw new Error(`Failed to fetch job tasks: ${response.error}`);
      }

      return response.data as MvpApiListAllJobTasksResponse;
    },
    enabled: !!queryParams,
    staleTime: 10 * 1000, // 10 seconds - data is stale after 10s
    gcTime: 5 * 60 * 1000, // 5 minutes - cache garbage collected after 5min
  });
}
